import module from './index'

let moduleName = 'module->' + module.info.name;

const routes = [
    {
        path: module.info.name,
        name: moduleName,
        component: () => import('./View.vue'),
        children: [
            {
                path: 'create',
                name: moduleName + '->create',
                component: () => import('./create/View'),
            },
            {
                path: 'lcr',
                name: moduleName + '->lcr',
                component: () => import('./lcr/View.vue'),
                children: [
                    {
                        path: 'top-destination',
                        name: moduleName + '->lcr->top-destination',
                        component: () => import('./lcr/top-destination/View.vue'),
                        children: [
                            {
                                path: ':listPage',
                                name: moduleName + '->lcr->top-destination->list->page',
                                component: () => import('./lcr/top-destination/page/View.vue'),
                            }
                        ]
                    },
                ]
            },
            {
                path: ':entityTitle',
                name: moduleName + '->view',
                component: () => import('./view/View.vue'),
            }
        ]
    }
];

export default routes
